import apiSlice from '@/store/api/apiSlice';
import { ContactSupportResponse, UserProfile, Wallet } from '@/types/user';

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET /users/me
    getUserProfile: builder.query<UserProfile, void>({
      query: () => ({
        url: '/users/me',
        method: 'GET',
        params: { t: Date.now() },
      }),
      // providesTags: ['UserDetails'],
    }),

    updateUserInfo: builder.mutation<
      { success: boolean; data: any; message?: string },
      {
        id: string | number;
        firstname: string;
        lastname: string;
        username: string;
        dialCode: string;
        mobile: string;
        country: string | undefined;
        email?: string | null;
        mobileVerificationCode?: string;
      }
    >({
      query: (body) => ({
        url: `users/me`,
        method: 'PATCH',
        body,
      }),
      // invalidatesTags: ['UserDetails'],
    }),

    // Get current user's wallets
    getUserWallets: builder.query<Wallet[], void>({
      query: () => ({
        url: `/users/me/wallets`,
        method: 'GET',
        // params: { t: Date.now() },
      }),
    }),

    getContactSupport: builder.query<ContactSupportResponse, void>({
      query: () => ({
        url: '/contact-support',
        method: 'GET',
        params: { t: Date.now() },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserProfileQuery,
  useGetUserWalletsQuery,
  useGetContactSupportQuery,
  useUpdateUserInfoMutation,
} = userApi;
